import React, { useState, useEffect } from "react";
import { search_filter_Stock } from "../../../../../../services/stock_service";

import {
  Dialog,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Tooltip,
  Fab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import PanToolAltTwoToneIcon from "@mui/icons-material/PanToolAltTwoTone";

const SearchStock = ({
  open,
  onClose,
  categories,
  get_supplier_by_id,
  suppliers,
  setexisting_products,
}) => {
  const [data, setData] = useState({ prodCategory: "", desc: "" });
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (data.prodCategory || data.desc) {
      handleSearch();
    }
  }, [data]);

  const handleSearch = async () => {
    try {
      const response = await search_filter_Stock(data);
      setResults(response.data.data);
    } catch (error) {
      console.error("Erreur lors de la recherche:", error);
    }
  };

  const handleClear = () => {
    setData({ prodCategory: "", desc: "" });
    setResults([]);
  };

  // const handleChooseFromStock = (product) => {
  //     console.log("choosed in search component",product);
  //     setexisting_products(prev => [...prev, product]);
  //     onClose();

  // }
  const handleChooseFromStock = (item) => {
    const supplierData = item.products_by_supplier[0] || {}; // Fallback to empty

    let transformedItem = {
      archived: item.archived,
      created_at: item.created_at,
      id: item.id,
      product_category: item.product_category,
      product_code: supplierData.product_code || "",
      product_description: item.product_description,
      product_name: item.product_name,
      product_price: item.average_price,
      product_quantity: item.product_quantity,
      product_quantity_selected: 0,
      product_reference: item.product_reference,
      requested_product_code: supplierData.product_code || "",
      requested_product_supplier: supplierData.supplier || "",
      supplier: supplierData.supplier || "",
      updated_at: supplierData.updated_at || item.updated_at,
    };

    // Directly push without checking for existing match
    setexisting_products((prev) => [...prev, transformedItem]);
    onClose();
  };

  return (
    <Dialog
      className="catalogue_modal"
      fullWidth={true}
      maxWidth={"xl"}
      open={open}
      onClose={onClose}
    >
      <div className="stock_list_container" style={{  padding: "10px 20px" }}>
        <div className="search_filter_container" style={{  marginBottom:"15px",width:"100%" }} >
          <Grid
            container
            spacing={1}
            alignItems="center"
            className="search_bar"
            style={{
              width: "auto",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "end",
              gap: "10px",
            }}
          >
            <Grid item>
              <TextField
                variant="standard"
                label="Chercher"
                className="search_bar"
                value={data.desc}
                onChange={(e) => setData({ ...data, desc: e.target.value })}
              />
            </Grid>
            <Grid item>
              <IconButton onClick={handleClear} style={{ padding: "0" }}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </div>

        {results.length > 0 && (
          <div className="commissions_table_container">
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow className="table_head_row">
                    <TableCell className="table_head_cell">
                      Nom Produit
                    </TableCell>
                    <TableCell className="table_head_cell">Référence</TableCell>
                    <TableCell className="table_head_cell">
                      Code Produit
                    </TableCell>
                    <TableCell className="table_head_cell">
                      ID Fournisseur
                    </TableCell>
                    <TableCell className="table_head_cell">Quantité</TableCell>
                    <TableCell className="table_head_cell"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {results.map((item, index) =>
                    item.products_by_supplier.map((supplier, sIndex) => (
                      <TableRow
                        key={`${index}-${sIndex}`}
                        className="table_row"
                      >
                        <TableCell>{item.product_name || "N/A"}</TableCell>
                        <TableCell>{item.product_reference || "N/A"}</TableCell>
                        <TableCell>{supplier.product_code || "N/A"}</TableCell>
                        <TableCell>
                          {get_supplier_by_id(supplier.supplier, suppliers) ||
                            "N/A"}
                        </TableCell>
                        <TableCell>
                          {supplier.product_quantity || "N/A"}
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Choisir">
                            <Fab className="add_new_object_fab add_new_object_fab_big">
                              <PanToolAltTwoToneIcon
                                className="my_icon"
                                onClick={() => handleChooseFromStock(item)}
                              />
                            </Fab>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default SearchStock;